import { DiaryStatisticTrend } from '../types/diaryTypes';

export const getRatingDescription = (index: number): string => {
  switch (index) {
    case 0:
      return 'Eher unangenehm';
    case 1:
      return 'Verbesserungswürdig';
    case 2:
      return 'In Ordnung';
    case 3:
      return 'Gut';
    case 4:
      return 'Sehr gut';
    default:
      return '';
  }
};

export const getTrendDescription = (trend: DiaryStatisticTrend): string => {
  switch (trend) {
    case 'slight improvement':
      return 'Tendenz: Leichte Verbesserung';
    case 'improvement':
      return 'Tendenz: Verbesserung';
    case 'slight deterioration':
      return 'Tendenz: Leichte Verschlechterung';
    case 'deterioration':
      return 'Tendenz: Verschlechterung';
    case 'constant':
      return 'Tendenz: Gleichbleibend';
    case 'fluctuating':
      return 'Tendenz: Schwankend';
    default:
      return '';
  }
};
